<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :viewBox="`0 0 ${width} ${height}`"
    :aria-labelledby="iconName"
    role="presentation"
  >
    <g :fill="iconColor">
      <path
        d="M17 3.66406H16.9609C16.9609 3.625 16.9219 3.54688 16.7266 3.39062C16.4531 3.15625 15.9453 2.88281 15.2422 2.60938C13.8359 2.10156 11.8047 1.75 9.5 1.75C7.15625 1.75 5.125 2.10156 3.71875 2.60938C3.01562 2.88281 2.50781 3.15625 2.23438 3.39062C2.03906 3.54688 2 3.625 2 3.66406V7.64844C2.54688 8.03906 3.44531 8.42969 4.65625 8.74219C6.02344 9.05469 7.70312 9.25 9.5 9.25C11.2969 9.25 12.9375 9.05469 14.3047 8.74219C15.5156 8.42969 16.4141 8.03906 17 7.64844V3.66406ZM17 9.09375C16.2969 9.44531 15.4766 9.71875 14.5781 9.95312C13.1328 10.3047 11.375 10.5 9.5 10.5C7.58594 10.5 5.82812 10.3047 4.38281 9.95312C3.48438 9.71875 2.66406 9.44531 2 9.09375V12.6484C2.54688 13.0391 3.44531 13.4297 4.65625 13.7422C6.02344 14.0547 7.70312 14.25 9.5 14.25C11.2969 14.25 12.9375 14.0547 14.3047 13.7422C15.5156 13.4297 16.4141 13.0391 17 12.6484V9.09375ZM2 17.375C2 17.4141 2.03906 17.4922 2.23438 17.6484C2.50781 17.8828 3.01562 18.1562 3.71875 18.4297C5.125 18.9375 7.15625 19.25 9.5 19.25C11.8047 19.25 13.8359 18.9375 15.2422 18.4297C15.9453 18.1562 16.4531 17.8828 16.7266 17.6484C16.9219 17.4922 16.9609 17.4141 17 17.375V14.0938C16.2969 14.4453 15.4766 14.7188 14.5781 14.9531C13.1328 15.3047 11.375 15.5 9.5 15.5C7.58594 15.5 5.82812 15.3047 4.38281 14.9531C3.48438 14.7188 2.66406 14.4453 2 14.0938V17.375ZM17 17.375C16.9609 17.375 16.9609 17.375 16.9609 17.375C16.9609 17.375 16.9609 17.375 17 17.375ZM1.96094 17.375H2H1.96094ZM1.96094 3.66406H2C1.96094 3.66406 1.96094 3.66406 1.96094 3.66406ZM17 3.66406H16.9609C16.9609 3.66406 16.9609 3.66406 17 3.66406ZM18.25 17.375C18.25 19.1328 14.3047 20.5 9.5 20.5C4.65625 20.5 0.75 19.1328 0.75 17.375V3.625C0.75 1.90625 4.65625 0.5 9.5 0.5C14.3047 0.5 18.25 1.90625 18.25 3.625V17.375Z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: 'box',
    },
    width: {
      type: [Number, String],
      default: 18,
    },
    height: {
      type: [Number, String],
      default: 18,
    },
    iconColor: {
      type: String,
      default: 'currentColor',
    },
  },
};
</script>
